import snapshot from "./generated/site-content.json" with { type: "json" };
import {
  hotspotCopySchema,
  siteCopySchema,
  type HotspotCopy,
} from "./schemas";

/**
 * Room and interface copy, authored in Sanity and pulled into
 * `generated/site-content.json` by `scripts/fetch-content.mjs`.
 *
 * Parsing happens at module load, exactly as it does for the cards and
 * recipes: an invalid snapshot fails `npm run build` rather than leaving a
 * blank heading in front of a visitor.
 */
export const siteCopy = siteCopySchema.parse(snapshot.siteCopy);

/**
 * The Studio hands these back as lists so an editor sees them in a stable
 * order; the code addresses them by id.
 */
function byId<T extends { id: string }>(
  items: readonly T[],
): Readonly<Record<T["id"], T>> {
  return Object.fromEntries(items.map((item) => [item.id, item])) as Record<
    T["id"],
    T
  >;
}

export const hotspotCopy = byId(hotspotCopySchema.parse(snapshot.hotspots));
export const entryIntentCopy = byId(siteCopy.entry.intents);
export const roomReactionCopy = byId(siteCopy.room.reactions);
export const seaOptionCopy = byId(siteCopy.sea.options);
export const hearthStepCopy = byId(siteCopy.hearth.steps);

export type { HotspotCopy };
